import { render, staticRenderFns } from "./editCustomer.vue?vue&type=template&id=44f36681&scoped=true&"
import script from "./editCustomer.vue?vue&type=script&lang=js&"
export * from "./editCustomer.vue?vue&type=script&lang=js&"
import style0 from "./editCustomer.vue?vue&type=style&index=0&id=44f36681&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f36681",
  null
  
)

component.options.__file = "editCustomer.vue"
export default component.exports